// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { ReactElement } from 'react';

import { Route } from 'react-router-dom';

import { Layout } from '~/components';

import { IBOSS } from '../pages';

function BillingRoutes(): ReactElement {
  return (
    <Layout title="I.BOSS">
      <Route path="/iboss" exact component={IBOSS.IBOSS} />
      <Route
        path="/iboss/student-charts"
        exact
        component={IBOSS.StudentsCharts}
      />
      <Route
        path="/iboss/trainer-charts"
        exact
        component={IBOSS.TrainersCharts}
      />
      <Route
        path="/iboss/finance-charts"
        exact
        component={IBOSS.FinanceCharts}
      />
      <Route path="/iboss/user-details/:userId" exact component={IBOSS} />
    </Layout>
  );
}

export default BillingRoutes;
